export const ME_QUERY_KEY = ["me"];
